var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/search-normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/search-normal_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-normal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6059 9.89575C16.0312 9.89575 9.89062 16.0363 9.89062 23.611C9.89062 31.1858 16.0312 37.3263 23.6059 37.3263C31.1806 37.3263 37.3212 31.1858 37.3212 23.611C37.3212 16.0363 31.1806 9.89575 23.6059 9.89575ZM6.76562 23.611C6.76562 14.3104 14.3053 6.77075 23.6059 6.77075C32.9065 6.77075 40.4462 14.3104 40.4462 23.611C40.4462 32.9117 32.9065 40.4513 23.6059 40.4513C14.3053 40.4513 6.76562 32.9117 6.76562 23.611Z",
    fill: "#0082CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.778 37.7841C38.3882 37.1739 39.3775 37.1739 39.9877 37.7841L42.7654 40.5618C43.3756 41.172 43.3756 42.1614 42.7654 42.7715C42.1553 43.3817 41.1659 43.3817 40.5557 42.7715L37.778 39.9938C37.1678 39.3836 37.1678 38.3943 37.778 37.7841Z",
    fill: "#0082CD"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBig);
export default __webpack_public_path__ + "static/media/search-big.9211ca6427d2d701b77c648afebdf014.svg";
export { ForwardRef as ReactComponent };